<template>
  <div class="body login">
    <div class="wrap">
      <h1 class="txt-center mb-20">
        <img src="../assets/img/logo.png" alt="" />
      </h1>
      <h2 class="txt-center bold font-20">수강신청 관리자</h2>
      <div class="box mt-20 pd-30">
        <div v-if="loginFailCount !== 0" style="padding-bottom: 30px">
          <div
            v-if="loginFailCount !== 0"
            style="
              height: 80px;
              width: 340px;
              background-color: rgb(251 201 17);
              padding: 10px;
              text-align: center;
            "
          >
            로그인 <span style="color: red">{{ loginFailCount }}</span
            >회 실패하였습니다. <br />
            로그인 연속 <span style="color: red">5</span>회 실패 시 로그인이
            <span style="color: red">차단</span>됩니다.
          </div>
        </div>
        <label for="" class="dp-block">
          <input
            type="text"
            placeholder="ID(E-mail)"
            v-model="id"
            class="w-100per mb-10"
          />
        </label>
        <label for="" class="dp-block">
          <input
            type="password"
            placeholder="Password"
            v-model="password"
            @keyup.enter="login()"
            class="w-100per mb-10"
          />
        </label>
        <p
          v-if="lock !== 'unlock'"
          class="txt-blue mb-10 underline txt-center pointer"
          @click="openModal()"
        >
          계정이 잠기셨나요? 비밀번호 찾기
        </p>
        <lock-modal v-if="isLockModalOpened" @close="closeModal"></lock-modal>
        <a class="pointer admin-btn-dark w-100per" @click="login()">Login</a>
      </div>
    </div>
  </div>
</template>

<script>
import LockModal from "@/components/LockModal.vue";
export default {
  components: {
    LockModal,
  },

  data: () => ({
    id: "",
    password: "",
    lock: "unlock",
    loginFailCount: 0,
    isLockModalOpened: false,
  }),
  mounted() {
    //   location.href="https://carrotians.net/";
  },

  methods: {
    login() {
      var params = new URLSearchParams();

      params.append("id", this.id);
      params.append("password", this.password);

      this.axios
        .post(this.axios.root + this.axios.port + "/login/admin", params)
        .then((res) => {
          console.log("res", res);
          if (res.data.err === 0) {
            localStorage.setItem("accessToken", res.data.accessToken);
            localStorage.setItem("regid", res.data.idx);
            localStorage.setItem("adminId", this.id);
            this.loginFailCount = res.data.loginFailCount;
            this.axios.defaults.headers.common["accessToken"] =
              res.data.accessToken;
            this.$router.push("/admin/list/main");
          } else if (res.data.err === 666) {
            alert(
              "5회 로그인 실패로 해당 계정은 잠겼습니다." +
                "\n" +
                "아래에 [계정이 잠기셨나요? 비밀번호 찾기]를 이용해주세요"
            );
            this.lock = "lock";
            this.loginFailCount = res.data.loginFailCount;
          } else if (res.data.err === 106) {
            alert(res.data.result);
          } else {
            this.loginFailCount = res.data.loginFailCount;
            alert(res.data.result);
          }
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    },
    // 모달 열기
    openModal() {
      this.isLockModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isLockModalOpened = false;
    },
  },
};
</script>
